import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ToastContainer } from "react-toastify";
import { UserContextProvider } from "./context/UserContext.component";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserContextProvider>
      <ToastContainer position="top-center" />
      <App />
    </UserContextProvider>
  </React.StrictMode>
);
